export function rankingThirdWords(selects) {
  const {
    head = {
      word: '',
    },
    second = {
      word: '',
    },
    third = {
      word: '',
    },
  } = selects;

  let results;
  if (second.position === 'before') {
    results = [second, head];
  } else {
    results = [head, second];
  }

  if (third.position === 'before') {
    results.unshift(third);
  } else {
    results.push(third);
  }

  console.log(results);

  return results;
}
